/**
 *
 * CreateDivisionModal
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import {
  makeSelectDivisionsNoParent,
  makeSelectIsLoadingCreate,
  makeSelectReset,
} from "./selectors"
import reducer from "./reducer"
import saga from "./saga"

import AddDivisionModal from "../../components/AddDivisionModal"

import { getSubdivisionsWithoutParent, createDivisionWatcher } from "./actions"

/* eslint-disable react/prefer-stateless-function */
export class CreateDivisionModal extends React.Component {
  constructor() {
    super()
    this.state = {
      divisionNoParents: [],
      selectedDivisions: [],
      valueOptionSelected: undefined,
      id_parent: undefined,
      division: "",
    }
  }

  resetModal = () => {
    this.setState({
      valueOptionSelected: undefined,
      selectedDivisions: [],
    })
  }

  componentDidMount() {
    if (this.props.resetDivisionForm) {
      this.state = {
        divisionNoParents: [],
        selectedDivisions: [],
        valueOptionSelected: undefined,
        id_parent: undefined,
      }
    }
  }

  changeSelectOption = (name, value) => {
    this.setState({ [name]: value })
  }

  addToSelected = () => {
    this.setState(
      {
        selectedDivisions: [
          ...this.state.selectedDivisions,
          this.state.valueOptionSelected,
        ],
      },
      () => {
        this.setState({ valueOptionSelected: undefined })
      }
    )
  }

  deleteFromSelected = (item) => {
    const newSelected = this.state.selectedDivisions.filter(
      (selected) => selected != item.id_division
    )
    this.setState({ selectedDivisions: newSelected })
  }

  saveNewDivision = () => {
    let params
    if (this.state.selectedDivisions.length > 0) {
      params = {
        id_company: this.props.data[0].id_company,
        name: this.state.division,
        id_parent: this.state.id_parent || "",
        subdivisions: this.state.selectedDivisions,
      }
    } else {
      params = {
        id_company: this.props.data[0].id_company,
        name: this.state.division,
        id_parent: this.state.id_parent || "",
      }
    }

    if(["Sin Asignar", "sin asignar", "Sin asignar"].includes(params.name)){
      return false
    }

    if(this.props.tableView == "1"){
      this.props.createDivisionProp(params)
    }
    else {
      this.props.createDivision(params)
    }
    
  }

  changeName = (name) => {
    this.setState({ division: name })
  }

  selectParentDivision = (id) => {
    this.setState({ id_parent: id })
  }

  render() {
    return (
      <AddDivisionModal
        superiorDivisions={this.props.data}
        divisionsSimple={this.props.divisionsSimple}
        visible={this.props.visible}
        valueOptionSelected={this.state.valueOptionSelected}
        selectedDivisions={this.state.selectedDivisions}
        divisionNoParents={this.props.divisionNoParents}
        changeSelectOption={this.changeSelectOption}
        onCancel={() => {
          this.props.onCancel()
          this.setState({ division: "", id_parent: undefined })
        }}
        addToSelected={this.addToSelected}
        deleteFromSelected={this.deleteFromSelected}
        onOk={() => {
          this.saveNewDivision()
          setTimeout(() => {
            this.setState({ id_parent: undefined })
          }, 800)
        }}
        changeName={this.changeName}
        id_parent={this.state.id_parent}
        selectParentDivision={this.selectParentDivision}
        isLoadingCreate={this.props.isLoadingCreateDivision}
        name={this.state.division}
        reset={this.props.resetDivisionForm}
        resetModal={this.resetModal}
      />
    )
  }
}

CreateDivisionModal.propTypes = {
  data: PropTypes.array.isRequired,
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
}

const mapStateToProps = createStructuredSelector({
  divisionNoParents: makeSelectDivisionsNoParent(),
  reset: makeSelectReset(),
})

function mapDispatchToProps(dispatch) {
  return { createDivision: (params) => dispatch(createDivisionWatcher(params)) }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "createDivisionModal", reducer })
const withSaga = injectSaga({ key: "createDivisionModal", saga })

export default compose(withReducer, withSaga, withConnect)(CreateDivisionModal)
